import {
  Component,
  Input
} from "@angular/core";

import { ComponentConfig } from "../../models/component-config.interface";
import { DynamicInterface } from "../../models/dynamic.interface";

@Component({
  exportAs: "dynamicComponents",
  selector: "app-dynamic-components",
  styleUrls: ["dynamic-components.component.css"],
  template: `
    <ng-template appDynamic [config]="configuration"> </ng-template>
  `
})
export class DynamicComponentsComponent
  implements DynamicInterface {
  @Input()
  configuration: ComponentConfig;

  constructor() { }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/containers/dynamic-components/dynamic-components.component.ts